module.exports = __webpack_public_path__ + "static/media/cp05.091179b6.png";